module.exports = __webpack_public_path__ + "8faa66990d66b4c7e6cf4d1e7342c94d.png";